import { useWindowDimensions } from "react-native";

import SplashScreenImage from "@/assets/images/splash-screen.png";
import { LoginTestID } from "@/constants/TestID";
import LoginScreenContainer from "@/ui/components/authentication/LoginScreenContainer";
import AppVersionLabel from "@/ui/components/common/AppVersionLabel";
import Image from "@/ui/core/Image";
import { Box } from "@/ui/layout";

interface EquipSplashScreenProps {
  transitionMs?: number;
}

const EquipSplashScreen = ({ transitionMs }: EquipSplashScreenProps = {}) => {
  const { width } = useWindowDimensions();
  return (
    <LoginScreenContainer testID={LoginTestID.Landing}>
      <Box
        alignItems="center"
        flex={1}
        justifyContent="center"
        testID={LoginTestID.SplashScreen}
      >
        <Image
          size={width * 0.5}
          testID={LoginTestID.Landing}
          transitionMs={transitionMs}
          uriSource={SplashScreenImage}
        />
      </Box>
      <AppVersionLabel testID={LoginTestID.Login} />
    </LoginScreenContainer>
  );
};

export default EquipSplashScreen;
